import { Component } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';
import addComponentAnimation from '@swisslife/shared-ui/src/utils/animations/js/animations';

enum Selectors {
	Title = '.js-o-grid-row__title',
}

@Component('GridRow')
export class GridRow extends GondelJqueryComponent {
	private controllersTitle: any[] = Array();

	public async sync() {
		this.controllersTitle = await addComponentAnimation(this.$ctx, Selectors.Title);
	}

	public stop() {
		for (const controller of this.controllersTitle) {
			controller.destroy(true);
		}
	}
}
